// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25138":"96c71981","34707":"597cd67f","91561":"e7fd799f"}[chunkId] + ".css";
};